export default "__VITE_ASSET__amwRjrHQ__"